import { render, staticRenderFns } from "./Adults.vue?vue&type=template&id=44be69fd&"
import script from "./Adults.vue?vue&type=script&lang=js&"
export * from "./Adults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports